<div
  [ngClass]="setAlertClasses()"
>
  <div class="col">
    <div class="flex flex-row">
      <div class="title">
        <mat-icon
          *ngIf="icon"
          [ngClass]="setIconClasses()" 
          class="topazio-margin-r-nano"
          >
          {{ icon }}
        </mat-icon>
  
        <span
          [ngClass]="setAlertTitleClasses()"
          *ngIf="title"
          class="average-bold align-end"
        >
          {{ title }}
        </span>
      </div>
  
      <div class="alert__message flex align-items-center">
        <ng-content
          select="div.alert__body__message"
        ></ng-content>
      </div>
    </div>
  
    <div>
      <ng-content 
        select="div.alert__body__content"
        class="alert__title__message"
      ></ng-content>
    </div>
  </div>
</div>
